//
import axios from 'axios'

//
import printVerify from './printVerify'

/**
 *
 */
const include = [
    'sl_ground_seller.hr_employee',
    'sl_customer.pch_payment_condition',
    'sl_customer.sl_customer_account',
    'sl_detail_ground_seller_payment_records.sl_customer_account_receivable.sl_sale_invoice',
]

/**
 *
 */
const fetchAll = async () => {
    //
    try {
        //
        const response = await axios.get(
            process.env.VUE_APP_API_ROUTE + '/sl_ground_seller_payment_record',
            {
                params: {
                    get_all_results: true,
                    include,
                },
            }
        )

        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

/**
 *
 */
const fetchById = async id => {
    //
    try {
        //
        const response = await axios.get(
            process.env.VUE_APP_API_ROUTE +
                '/sl_ground_seller_payment_record/' +
                id,
            {
                params: {
                    get_all_results: true,
                    include,
                },
            }
        )

        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

/**
 *
 */
const verify = async payment => {
    //
    try {
        //
        const response = await axios.post(
            process.env.VUE_APP_API_ROUTE +
                '/pos_customer_receivable_payment/ground_seller',
            payment
        )
        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default {
    fetchAll,
    fetchById,
    printVerify,
    verify,
}
